import { render, staticRenderFns } from "./defaultForm.vue?vue&type=template&id=2e9f914c&scoped=true"
import script from "./defaultForm.vue?vue&type=script&lang=js"
export * from "./defaultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9f914c",
  null
  
)

export default component.exports